<template>
  <section class="section section-sm section-shaped overflow-hidden my-0 bg-darker">
    <!-- <div class="shape shape-style-1 shape-default shape-skew"> -->
    <div class="shape shape-style-none shape-dark">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container py-0">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-4 mb-5 mb-lg-0">
          <h2 class="text-ferdas h2">Featured Hostel</h2>
          <h3 class="text-white h4">Albertfred Hostel</h3>
          <p class="lead text-white mt-4">Hostel Location: Kwaprow</p>
          <p class="text-white">Number of rooms: 20 </p>
          <p class="text-white">Hostel rating: 4+</p>
          <!-- <a href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
          class="btn btn-white mt-4">See all components</a>-->
        </div>
        <div class="col-lg-8 mb-lg-auto">
          <!-- <div class="rounded shadow-lg overflow-hidden transform-perspective-right"> -->
          <div class="rounded shadow-sm overflow-hidden">
            <b-carousel id="carousel1" controls indicators>
              <!-- Text slides with image -->
              <b-carousel-slide img-src="/img/hostels/albertfred-room.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/hostels/albertfred-room-bed.jpg"></b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// import BCarousel from "bootstrap-vue/es/components/carousel/carousel";
// import BCarouselSlide from "bootstrap-vue/es/components/carousel/carousel-slide";
import { BCarousel } from "bootstrap-vue";
import { BCarouselSlide } from "bootstrap-vue";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
